import { type ReactNode, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from './useAuthContext';

export function AuthGate({ children }: { children: ReactNode }) {
  const { state } = useAuthContext();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!state.loading && !state.me) {
      const next = encodeURIComponent(location.pathname + location.search);
      navigate(`/login?next=${next}`, { replace: true });
    }
  }, [state.loading, state.me, location, navigate]);

  if (state.loading) {
    return (
      <div className="grid min-h-[100dvh] place-items-center bg-background text-muted-foreground">
        <p className="text-sm">Loading…</p>
      </div>
    );
  }
  if (!state.me) return null;
  return <>{children}</>;
}
